import classNames from 'classnames';
import { Typography as Paragraph } from 'components';
import HelpIcon from 'assets/icons/help.svg?react';
import { cn } from 'utils/cn';

type Props = {
  heading?: string;
  description: string;
  showIcon?: boolean;
  textAlignment?: 'center' | 'start';
  className?: string;
  classNameTitle?: string;
};

export default function HelpBlock({
  heading,
  description,
  showIcon = true,
  textAlignment = 'start',
  className,
  classNameTitle,
}: Props) {
  return (
    <div
      className={classNames(
        'flex mt-10',
        textAlignment === 'center' ? 'text-center' : 'text-start',
        className,
      )}
    >
      {showIcon && (
        <div className="mr-5">
          <HelpIcon data-test="helpBlock-icon" />
        </div>
      )}
      <div className="max-w-[300px]">
        {heading && (
          <Paragraph
            className={cn('font-bold', classNameTitle)}
            dataTest="helpBlock-heading"
          >
            {heading}
          </Paragraph>
        )}
        <div
          className="text-muted text-xs font-normal leading-[15px] mt-[3px] [&>a]:text-primary [&>a]:inline-block"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
          data-test="helpBlock-info-text"
        />
      </div>
    </div>
  );
}
